import React, { useEffect, useState } from 'react';
import Modal from '@medflex/components/stories/Modal';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import useChatContacts from '../../hooks/useChatContacts';
import useModal from '../../hooks/useModal';
import ContactsSelector from './ContactsSelector';
import MessageComposer from './MessageComposer';

const MulticastModule = () => {
  useChatContacts();
  const { close } = useModal();
  const [forceMulticast, setForceMulticast] = useState(false);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [contactsSelected, setContactsSelected] = useState(false);
  const { t } = useTranslation('physician');
  const [message, setMessage] = useState('');
  const location = useLocation();

  const handleClose = e => {
    e.preventDefault();
    if (contactsSelected) {
      setContactsSelected(false);
      return;
    }
    close({ modal: 'multicast' });
  };

  useEffect(() => {
    const { state } = location;
    if (state && state.selectedContact) {
      setSelectedContacts([state.selectedContact]);
    }
    if (state && state.content) {
      setMessage(state.content);
      // if there is a predefined message, we don't want to go to chat in case only one contact is selected
      // therefore we show multicast even for one contact
      setForceMulticast(true);
    }
  }, [location]);

  const handleSelectedContactsChanged = ({ contact }) => {
    if (selectedContacts.map(({ user }) => user.id).includes(contact.user.id)) {
      setSelectedContacts(selectedContacts.filter(({ user }) => user.id !== contact.user.id));
      return;
    }
    setSelectedContacts([...selectedContacts, contact]);
  };

  const setMultipleContacts = contacts => {
    setSelectedContacts(contacts);
  };

  return (
    <Modal
      showCloseButton
      title={t('messenger:MulticastModule.title')}
      className="min-h-0 flex flex-col"
      onClickCloseButton={handleClose}
    >
      <div className="flex flex-col min-h-0" data-component="MulticastModule">
        {contactsSelected ? (
          <MessageComposer
            selectedContacts={selectedContacts}
            message={message}
            setMessage={setMessage}
            onRecipientRemoved={handleSelectedContactsChanged}
            onBack={handleClose}
          />
        ) : (
          <ContactsSelector
            selectedContacts={selectedContacts}
            onClickContinue={() => setContactsSelected(true)}
            onSelect={handleSelectedContactsChanged}
            forceMulticast={forceMulticast}
            setMultipleContacts={setMultipleContacts}
          />
        )}
      </div>
    </Modal>
  );
};

export default MulticastModule;
